import { z } from "zod";

export const CreateTermsAndConditionSchema = z.object({
    template_name: z.string().min(1, "Template name is required"),
    terms_and_conditions: z
        .array(z.string().min(1, "Term cannot be empty"))
        .min(1, "At least one term is required"),
});

export const UpdateTermsAndConditionSchema = CreateTermsAndConditionSchema;

export const TermsAndConditionFormSchema = CreateTermsAndConditionSchema.extend(
    {
        terms_and_conditions: z
            .array(
                z.object({ value: z.string().min(1, "Term cannot be empty") }),
            )
            .min(1, "At least one term is required"),
    },
);

export type CreateTermsAndConditionSchema = z.infer<
    typeof CreateTermsAndConditionSchema
>;
export type UpdateTermsAndConditionSchema = z.infer<
    typeof UpdateTermsAndConditionSchema
>;
export type TermsAndConditionFormSchema = z.infer<
    typeof TermsAndConditionFormSchema
>;
